import {IntegrationCard, RudderstackIcon} from "@tinct/web-components";
import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {useDeleteCrmIntegration, useGetOrganizationById} from "@tinct/core-api";
import {useMemo, useState} from "react";
import {RudderstackConfigModal} from "../modals/rudderstack-config-modal";

export const RudderstackIntegration = () => {
  const workspaceId = useGetCurrentWorkspaceId();

  const [configOpen, setConfigOpen] = useState(false);

  const { mutate: deleteCrmIntegration } = useDeleteCrmIntegration();

  const { data: organization } = useGetOrganizationById({
    id: workspaceId,
    fields: {
      crmIntegrations: {
        fields: {
          id: null,
          providerType: null,
          status: null,
          errorDetails: null,
        }
      }
    }
  }, {
    enabled: !!workspaceId,
  });

  const rudderstackIntegration = useMemo(() => {
    return organization?.crmIntegrations?.find(integration => integration.providerType === 'rudderstack');
  }, [organization]);

  const connected = !!rudderstackIntegration;

  const handleDisconnectRudderstack = () => {
    if (!workspaceId || !rudderstackIntegration?.id) return;
    deleteCrmIntegration({
      integrationId: rudderstackIntegration.id,
      organizationId: workspaceId,
    })
  }

  return (
    <>
      <IntegrationCard
        title="RudderStack"
        description="Stream visitor engagement events to your RudderStack data plane"
        status={connected ? "connected" : "not-connected"}
        icon={<RudderstackIcon width={40} height={40}/>}
        active={true}
        enabled={connected}
        onSettingsClick={connected ? () => setConfigOpen(true) : undefined}
        onEnabledChange={(enabled) => {
          if (enabled) {
            setConfigOpen(true);
          } else {
            handleDisconnectRudderstack();
          }
        }}
      />
      {workspaceId && (
        <RudderstackConfigModal
          open={configOpen}
          onOpenChange={setConfigOpen}
          organizationId={workspaceId}
          integrationId={rudderstackIntegration?.id ?? undefined}
        />
      )}
    </>
  );
}
